import React from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from '../../firebaseConfig';
import Alert from '@material-ui/lab/Alert';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { NewUserContext, UserContext } from '../../App';
import { useState } from 'react';

if(firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
  }


const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
  }));

const Login = () => {
  const history = useHistory();
  const location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };
    const classes = useStyles();
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const [newUser, setNewUser] = useContext(NewUserContext);
    const [error, setError] = useState('')
    
    const handleBlur = (e) => {
        let isField
        if(e.target.name === 'email1') {
            setError('')
            isField = /\S+@\S+\.\S+/.test(e.target.value) || setError('Please provide a valid email')
        }
        if(e.target.name === 'password') {
            setError('')
            isField = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(
            e.target.value) || setError('Password should contain at least 8 characters, one uppercase letter and one number')
        }
        if(isField) {
            setLoggedInUser({...loggedInUser, [e.target.name] : e.target.value})
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        firebase.auth().signInWithEmailAndPassword(loggedInUser.email1, loggedInUser.password)
        .then((userCredential) => {
            var user = userCredential.user;
            setNewUser(false);
            setLoggedInUser(user)
            console.log(user)
            history.replace(from);

        })
        .catch((error) => {
            setError('')
            const errorMessage = error.message;
            setError(errorMessage)
        });
    }

    return (
    <div className="text-center">
        <img src={require('../../images/logo.png').default} alt="" style={{width: '300px', marginTop: '50px'}}/>
        <form className={classes.root} noValidate autoComplete="off" className="d-flex flex-column justify-content-center align-items-center" onSubmit={handleSubmit}>
        {error && <Alert severity="error" style={{width: '400px', marginTop: '20px'}}>{error}</Alert>}
        <TextField  label="Email" variant="filled" color="secondary" style={{width: '400px', marginBottom: '20px', marginTop: '80px'}} name="email1" onBlur={handleBlur} required/>
        <TextField  label="Password" variant="filled" color="secondary" style={{width: '400px', marginBottom: '20px'}} name="password" onBlur={handleBlur} required type="password" />
        <Button variant="contained" color="secondary" style={{width: '400px', height: '50px'}} className="mb-2" type="submit">
        Sign in
      </Button>  
        </form>
    <Link to='/signup' style={{color: '#DC0095'}}><p>Don't have an account</p></Link> 
    </div>
    );
};

export default Login;